import { ClipboardDocumentIcon } from '@heroicons/react/24/outline'
import { Modal } from 'stories/components'
import { copyClipboard } from 'utils/copyClipboard'

/**
 * The one-time reveal. This is the only moment the key exists anywhere outside the integration
 * that will use it - the server keeps a hash, so there is nothing to show a second time. The copy
 * button and the warning are the whole point of the screen.
 */
export const ApiKeyCreatedModal = ({ name, apiKey, onClose }: { name: string; apiKey: string; onClose: Function }) => {
  return (
    <Modal isOpen title="API Key Created" titleOkay="Done" titleCancel="" onClose={() => onClose()} onOk={() => onClose()}>
      <div className="w-128">
        <p className="text-sm text-gray-600 mb-1">
          Key for <span className="font-semibold">{name}</span>
        </p>
        <p className="text-sm text-red-600 mb-4">
          Copy it now. This is the only time it will be shown &mdash; it is stored as a hash and cannot be recovered.
        </p>

        <div className="flex items-stretch gap-2 mb-4">
          <code className="flex-1 break-all rounded border border-gray-200 bg-gray-50 px-3 py-2 font-mono text-sm">
            {apiKey}
          </code>
          <button
            type="button"
            className="shrink-0 rounded border border-gray-200 px-3 hover:bg-gray-50"
            onClick={() => copyClipboard(apiKey)}
            aria-label="Copy API key"
          >
            <ClipboardDocumentIcon className="w-5 h-5 text-shade-blue" />
          </button>
        </div>

        <p className="text-sm text-gray-500">
          Send it to the integrator through a secret-sharing tool rather than email or chat. It is sent as the
          <span className="font-mono"> Authorization </span>
          header with no <span className="font-mono">Bearer</span> prefix.
        </p>
      </div>
    </Modal>
  )
}
